import React from 'react';
import { Users, User, Mail } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const Equipo = () => {
  const orgChart = {
    notarios: [
      { nombre: 'Ricardo Dehesa Cortés', puesto: 'Notario Titular', correo: 'ricardodehesa@notariapublica90.com' },
      { nombre: 'Abraham Cruz Zamudio', puesto: 'Notario Auxiliar', correo: 'abrahamcruzzamudio@notariapublica90.com' }
    ],
    directorJuridico: { nombre: 'Clever Alberto Rodríguez Barbeiro', puesto: 'Director Jurídico', correo: 'cleverrodriguez@notariapublica90.com' },
    abogadosSenior: [
      { nombre: 'Hazael Augusto Narváez Jiménez', puesto: 'Coordinador Jurídico y Administrativo', correo: 'hazael.narvaez@notariapublica90.com' },
      { nombre: 'Josué Alexander Mukul Canul', puesto: 'Abogado Senior', correo: 'josue.mukul@notariapublica90.com' },
      { nombre: 'Shirley Alondra Koo Ceme', puesto: 'Abogada Senior', correo: 'shirley.c@notariapublica90.com' },
      { nombre: 'Viviana Berenice Aké Vázquez', puesto: 'Abogada Senior', correo: 'vivianaake@notariapublica90.com' },
      { nombre: 'Kervin Arnold Alpuche Matos', puesto: 'Abogado Senior', correo: 'kervinalpuche@notariapublica90.com' },
      { nombre: 'José Ronaldo Llanes Contreras', puesto: 'Abogado Senior', correo: 'jose.llanes@notariapublica90.com' },
      { nombre: 'Alondra Izquierdo Dzib', puesto: 'Abogada Senior', correo: 'alondraizquierdo@notariapublica90.com' },
      { nombre: 'Andrea Oropeza Hernández', puesto: 'Abogada Senior', correo: 'andrea.oropezahernandez@notariapublica90.com' }
    ],
    abogadosJunior: [
      { nombre: 'Ricardo Alberto Chuayo López', puesto: 'Abogado Junior', correo: 'ricardo.chuayo@notariapublica90.com' },
      { nombre: 'Grecia Alejandra Rosado', puesto: 'Abogada Junior', correo: 'grecia.rosado@notariapublica90.com' },
      { nombre: 'Lilia Jazmín Jiménez Arévalo', puesto: 'Abogada Junior', correo: 'liliajimenez@notariapublica90.com' },
      { nombre: 'Alfonso Lomas Fernández', puesto: 'Abogado Junior', correo: 'alfonso.lomasfernandez@notariapublica90.com' },
      { nombre: 'Heidi Orfilda De La Paz Miranda', puesto: 'Abogada Junior' },
      { nombre: 'Nelis de Jesús Amador Cruz', puesto: 'Abogado Junior' }
    ],
    auxiliarJuridico: [
      { nombre: 'Luis Armando Tuz Dzidz', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Didier Rubén Cauich Mac', puesto: 'Auxiliar Jurídico' },
      { nombre: 'América Trujillo Camacho', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Juan Hernández Saldaña', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Gabriela Briyeth Juárez Rentería', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Johan David Balan Jesús', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Fernando Sequeda Román', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Victor Manuel Robles Salvador', puesto: 'Auxiliar Jurídico', correo: 'victor.robles@notariapublica90.com' },
      { nombre: 'Vanessa Paulina Mendoza Pérez', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Jenifer Estrella García Pat', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Diana Itzel Dolores Albornoz', puesto: 'Auxiliar Jurídico' },
      { nombre: 'Carlos García Selaya', puesto: 'Auxiliar Jurídico' }
    ],
    pasantes: [
      { nombre: 'Luisa Fernanda Brito Valdez', puesto: 'Pasante' },
      { nombre: 'Elvis Giovanni Martínez Domínguez', puesto: 'Pasante' }
    ],
    direccionGeneral: [
      { nombre: 'Luisina Villa', puesto: 'Directora General', correo: 'luisinavilla@notariapublica90.com' }
    ],
    direccionTI: [
      { nombre: 'Daniel Sánchez Pérez', puesto: 'Director de TI', correo: 'daniel.sanchezperez@notariapublica90.com' }
    ],
    contraloria: [
      { nombre: 'Yessica Alejandra De La Garza Espinosa', puesto: 'Contralora', correo: 'yessica.delagarza@notariapublica90.com' },
      { nombre: 'Saul Natanael Yam Sulub', puesto: 'Aux. Jurídico / Contraloría', correo: 'saul.yam@notariapublica90.com' },
      { nombre: 'Vianca Aurora Camacho Aké', puesto: 'Aux. de Contraloría' }
    ],
    administracion: [
      { nombre: 'Nayeli del Rosario Aguilar Pérez', puesto: 'Administradora', correo: 'nayeli.aguilar@notariapublica90.com' },
      { nombre: 'Jesús Rodrigo Gutiérrez Castro', puesto: 'Aux. Administrativo' },
      { nombre: 'Antonio Vera Pérez', puesto: 'Gestor', correo: 'recepcion@notariapublica90.com' },
      { nombre: 'César Armando Díaz Navarro', puesto: 'Gestor' },
      { nombre: 'Andrik Rodríguez Rodríguez', puesto: 'Gestor' }
    ],
    contabilidad: [
      { nombre: 'Gerardo Sánchez Corona', puesto: 'Contador', correo: 'gerardosanchez@notariapublica90.com' },
      { nombre: 'Leydi Vanessa García Gómez', puesto: 'Aux. de Contaduría' }
    ],
    recepcion: [
      { nombre: 'Valeria Gissel González Sandoval', puesto: 'Recepción', correo: 'recepcion@notariapublica90.com' },
      { nombre: 'Ana Paola Ramírez Mejía', puesto: 'Recepción', correo: 'recepcion@notariapublica90.com' },
      { nombre: 'Dayanara Cámara Cauich', puesto: 'Recepción', correo: 'recepcion@notariapublica90.com' }
    ],
    publirelacionistas: [
      { nombre: 'Jennifer Cassandra Ortega Martínez', puesto: 'Directora Creativa & Publirelacionista', correo: 'cazziee53@gmail.com' },
      { nombre: 'Israel Lazo', puesto: 'Publirelacionista' }
    ]
  };

  const OrgCard = ({ persona, color = "blue" }) => (
    <div className={`bg-white border-2 border-${color}-200 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-300 hover:border-${color}-400`}>
      <div className="flex items-start gap-2">
        <User className={`w-4 h-4 text-${color}-600 flex-shrink-0 mt-1`} />
        <div className="flex-1 min-w-0 text-left">
          <p className="text-sm font-bold text-gray-900 break-words text-left">{persona.nombre}</p>
          <p className="text-xs text-gray-600 text-left">{persona.puesto}</p>
          {persona.correo && (
            <a
              href={`mailto:${persona.correo}`}
              data-testid={`equipo-email-${persona.nombre.toLowerCase().replace(/\s+/g, '-')}`}
              title={persona.correo}
              aria-label={`Enviar correo a ${persona.nombre}`}
              className="mt-2 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-notaria-secondary text-white text-xs font-medium hover:bg-notaria-primary transition-colors duration-200"
            >
              <Mail className="w-3.5 h-3.5 flex-shrink-0" />
              Enviar correo
            </a>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-50 pt-20">
      {/* Hero Section */}
      <section className="py-12 bg-gradient-to-r from-notaria-primary to-notaria-secondary text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
              <Users className="w-5 h-5" />
              <span className="font-semibold">Organigrama Notaría 90</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Nuestro Equipo Profesional
            </h1>
            <p className="text-xl text-gray-100">
              Estructura organizacional comprometida con la excelencia
            </p>
          </div>
        </div>
      </section>

      {/* Organigrama */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto space-y-8">
            
            {/* Notario Titular - Destacado */}
            <div className="text-center mb-12">
              <h3 className="text-2xl font-bold text-notaria-primary mb-6">Notario Titular</h3>
              <div className="flex justify-center">
                <div className="w-auto max-w-2xl">
                  <div className="bg-gradient-to-br from-notaria-primary to-notaria-secondary p-6 rounded-lg shadow-xl">
                    <div className="bg-white rounded-lg p-6">
                      <div className="flex items-center justify-center gap-4">
                        <User className="w-8 h-8 text-notaria-primary flex-shrink-0" />
                        <div className="text-center">
                          <h4 className="font-bold text-notaria-primary text-2xl whitespace-nowrap">{orgChart.notarios[0].nombre}</h4>
                          <p className="text-base text-notaria-secondary font-semibold mt-1">{orgChart.notarios[0].puesto}</p>
                          <a
                            href={`mailto:${orgChart.notarios[0].correo}`}
                            data-testid="equipo-email-notario-titular"
                            aria-label="Enviar correo al Notario Titular"
                            className="mt-3 inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-notaria-secondary text-white text-sm font-medium hover:bg-notaria-primary transition-colors duration-200"
                          >
                            <Mail className="w-4 h-4" />
                            Enviar correo
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Notario Auxiliar */}
            <div className="text-center">
              <h3 className="text-xl font-bold text-notaria-primary mb-4">Notario Auxiliar</h3>
              <div className="flex justify-center">
                <div className="w-64">
                  <OrgCard persona={orgChart.notarios[1]} color="blue" />
                </div>
              </div>
            </div>

            {/* Dirección Jurídica */}
            <div className="text-center pt-6">
              <h2 className="text-3xl font-bold text-notaria-primary mb-2">Dirección Jurídica</h2>
              <div className="w-24 h-1 bg-notaria-secondary mx-auto rounded-full"></div>
            </div>

            {/* Director Jurídico */}
            <div className="text-center" data-testid="equipo-director-juridico">
              <h3 className="text-xl font-bold text-notaria-primary mb-4">Director Jurídico</h3>
              <div className="flex justify-center">
                <div className="w-80">
                  <OrgCard persona={orgChart.directorJuridico} color="indigo" />
                </div>
              </div>
            </div>

            {/* Abogados Senior */}
            <div>
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Abogados Senior</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {orgChart.abogadosSenior.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="indigo" />
                ))}
              </div>
            </div>

            {/* Abogados Junior */}
            <div>
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Abogados Junior</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {orgChart.abogadosJunior.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="cyan" />
                ))}
              </div>
            </div>

            {/* Auxiliares Jurídicos */}
            <div>
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Auxiliares Jurídicos</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {orgChart.auxiliarJuridico.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="teal" />
                ))}
              </div>
            </div>

            {/* Pasantes */}
            <div data-testid="equipo-pasantes">
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Pasantes</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
                {orgChart.pasantes.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="sky" />
                ))}
              </div>
            </div>

            {/* Contraloría */}
            <div>
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Contraloría</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
                {orgChart.contraloria.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="pink" />
                ))}
              </div>
            </div>

            {/* Dirección General — big section header */}
            <div className="text-center pt-6">
              <h2 className="text-3xl font-bold text-notaria-primary mb-2">Dirección General</h2>
              <div className="w-24 h-1 bg-notaria-secondary mx-auto rounded-full"></div>
            </div>

            {/* Dirección General (titular) */}
            <div className="text-center">
              <h3 className="text-xl font-bold text-notaria-primary mb-4">Directora General</h3>
              <div className="flex justify-center">
                <div className="w-64">
                  <OrgCard persona={orgChart.direccionGeneral[0]} color="purple" />
                </div>
              </div>
            </div>

            {/* Administración */}
            <div>
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Administración</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                {orgChart.administracion.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="orange" />
                ))}
              </div>
            </div>

            {/* Contabilidad */}
            <div>
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Contabilidad</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
                {orgChart.contabilidad.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="green" />
                ))}
              </div>
            </div>

            {/* Recepción */}
            <div>
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Recepción</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
                {orgChart.recepcion.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="yellow" />
                ))}
              </div>
            </div>

            {/* Publirelacionistas */}
            <div>
              <h3 className="text-xl font-bold text-notaria-primary mb-4 text-center">Publirelacionistas</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
                {orgChart.publirelacionistas.map((persona, idx) => (
                  <OrgCard key={idx} persona={persona} color="red" />
                ))}
              </div>
            </div>

            {/* Dirección de TI — moved to the bottom */}
            <div className="text-center pt-6">
              <h3 className="text-xl font-bold text-notaria-primary mb-4">Dirección de TI</h3>
              <div className="flex justify-center">
                <div className="w-64">
                  <OrgCard persona={orgChart.direccionTI[0]} color="purple" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-notaria-primary text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto text-center">
            <div>
              <div className="text-5xl font-bold mb-2">45+</div>
              <div className="text-xl">Profesionales</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">10+</div>
              <div className="text-xl">Departamentos</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">100%</div>
              <div className="text-xl">Comprometidos</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Equipo;